///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/components/presenters/percentage/defaults"/>
export function get() {
    return {
        template: "presenters-percentage-default",
        resolution: 2,
        trimZeros: true
    };
}